// Lead action types
export const LEAD_DETAILS_SUCCESS = "LEAD_DETAILS_SUCCESS";
export const LEAD_DETAILS_FAILURE = "LEAD_DETAILS_FAILURE";
export const LEAD_DETAILS_RESET = "LEAD_DETAILS_RESET";

export const LEAD_SET_LOADING = "LEAD_SET_LOADING";
export const LEAD_SET_ERROR = "LEAD_SET_ERROR";
export const LEAD_CLEAR_ERROR = "LEAD_CLEAR_ERROR";

// Optional: for lead management operations
export const LEAD_MANAGE_REQUEST = "LEAD_MANAGE_REQUEST";
export const LEAD_MANAGE_SUCCESS = "LEAD_MANAGE_SUCCESS";
export const LEAD_MANAGE_FAILURE = "LEAD_MANAGE_FAILURE";

// Add these to your existing LeadActionType.ts

// Add Lead API
export const LEAD_ADD_REQUEST = "LEAD_ADD_REQUEST";
export const LEAD_ADD_SUCCESS = "LEAD_ADD_SUCCESS";
export const LEAD_ADD_FAILURE = "LEAD_ADD_FAILURE";

// Reset add lead state
export const LEAD_ADD_RESET = "LEAD_ADD_RESET";